import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { InspectionService } from 'src/app/services/inspection.service';
declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-inspection',
  templateUrl: './inspection.component.html',
  styleUrls: ['./inspection.component.css']
})
export class InspectionComponent implements OnInit {

  inspectionForm: FormGroup;
  addBtn = true;
  editInspectionId: any;
  dateOfInspectionModel: any;
  dateOfReceiptModel: any;
  dateOfSupplyModel: any;
  ecsList: any = [];
  TodayDate: any;
  disabledOnclick: boolean;

  constructor(private InspectionService: InspectionService, private alert: AlertComponent, 
    private commonFunction: CommonFunction, private router: Router, private activatedRoute: ActivatedRoute,
    private customvalidations: CustomValidation) { }

  ngOnInit() {
    this.inspectionForm = new FormGroup({
      dateOfInspection: new FormControl('', [Validators.required]),
      inspectionTimefrom: new FormControl('', []),
      inspectionTimeto: new FormControl('', []),
      personwhoInspected: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z' ]*$"), this.customvalidations.noWhitespaceValidator]),
      addressOfPerson: new FormControl('', []),
      designationOfPerson: new FormControl('', [Validators.pattern("^[a-zA-Z.' ]*$")]),
      regdID: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      shares: new FormControl('', []),
      natureOfDocument: new FormControl('', []),
      particulars: new FormControl('', []),
      copyProvided: new FormControl('', []),
      fees: new FormControl('', []),
      dateOfReceipt: new FormControl('', []),
      dateOfSupply: new FormControl('', []),
      remarks: new FormControl('', []),
    })

    $(function () {
      $('.timepicker-init').datetimepicker({
        widgetPositioning: {
          horizontal: 'left'
        },
        icons: {
          time: "fa fa-clock-o",
          date: "fa fa-calendar",
          up: "fa fa-arrow-up",
          down: "fa fa-arrow-down",
          previous: 'fa fa-arrow-left',
          next: 'fa fa-arrow-right'
        },
        format: 'LT'
      });
    })

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = false;
        this.editInspectionId = params['particularId'];
        this.getRegisterDirectorDataById(this.editInspectionId);
      } else {
        this.addBtn = true;
      }
    })
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['inspectionList']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  showFormEntry() {
    this.disabledOnclick = true;
    var object = {
      dateOfInspection: this.setDate(this.inspectionForm.controls.dateOfInspection.value),
      inspectionTimefrom: this.inspectionForm.controls.inspectionTimefrom.value,
      inspectionTimeto: this.inspectionForm.controls.inspectionTimeto.value,
      personwhoInspected: this.inspectionForm.controls.personwhoInspected.value,
      addressOfPerson: this.inspectionForm.controls.addressOfPerson.value,
      designationOfPerson: this.inspectionForm.controls.designationOfPerson.value,
      regdID: this.inspectionForm.controls.regdID.value,
      shares: this.inspectionForm.controls.shares.value,
      natureOfDocument: this.inspectionForm.controls.natureOfDocument.value,
      particulars: this.inspectionForm.controls.particulars.value,
      copyProvided: this.inspectionForm.controls.copyProvided.value,
      fees: this.inspectionForm.controls.fees.value,
      dateOfReceipt: this.setDate(this.inspectionForm.controls.dateOfReceipt.value),
      dateOfSupply: this.setDate(this.inspectionForm.controls.dateOfSupply.value),
      remarks: this.inspectionForm.controls.remarks.value,
    }

    this.InspectionService.sampleEcsRecord(object).subscribe(response => {
      if (response.status == 0) {
        this.disabledOnclick = false;
        this.alert.successWithOk(response.message, 'inspectionList');
      } else {
        // this.alert.error("Oops, Something went wrong");
        if(response.err_fields){
        this.alert.error(response.err_fields + ' fields are required or invalid.');
        }
        else{
          this.alert.error(response.message);
        }
      }
    })
  }

  getRegisterDirectorDataById(id) {
    this.InspectionService.getRegisterDirectorById(id).subscribe(response => {
      if (response.status == 0) {
        var inspectionById = response.data[0];
        this.inspectionForm.controls.inspectionTimefrom.setValue(inspectionById.inspectionTimefrom);
        this.inspectionForm.controls.inspectionTimeto.setValue(inspectionById.inspectionTimeto);
        this.inspectionForm.controls.personwhoInspected.setValue(inspectionById.personwhoInspected);
        this.inspectionForm.controls.addressOfPerson.setValue(inspectionById.addressOfPerson);
        this.inspectionForm.controls.designationOfPerson.setValue(inspectionById.designationOfPerson);
        this.inspectionForm.controls.regdID.setValue(inspectionById.regdID);
        this.inspectionForm.controls.shares.setValue(inspectionById.shares);
        this.inspectionForm.controls.natureOfDocument.setValue(inspectionById.natureOfDocument);
        this.inspectionForm.controls.particulars.setValue(inspectionById.particulars);
        this.inspectionForm.controls.copyProvided.setValue(inspectionById.copyProvided);
        this.inspectionForm.controls.fees.setValue(inspectionById.fees);
        this.inspectionForm.controls.remarks.setValue(inspectionById.remarks);

        if (inspectionById.dateOfInspection != null) {
          let dt = new Date(this.setFormatDate(inspectionById.dateOfInspection));
          this.dateOfInspectionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (inspectionById.dateOfReceipt != null) {
          let dt = new Date(this.setFormatDate(inspectionById.dateOfReceipt));
          this.dateOfReceiptModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (inspectionById.dateOfSupply != null) {
          let dt = new Date(this.setFormatDate(inspectionById.dateOfSupply));
          this.dateOfSupplyModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      }
    })
  }

  updateInspectionData() {
    this.disabledOnclick = true;
    var inspectionObject = {
      dateOfInspection: this.setDate(this.inspectionForm.controls.dateOfInspection.value),
      inspectionTimefrom: this.inspectionForm.controls.inspectionTimefrom.value,
      inspectionTimeto: this.inspectionForm.controls.inspectionTimeto.value,
      personwhoInspected: this.inspectionForm.controls.personwhoInspected.value,
      addressOfPerson: this.inspectionForm.controls.addressOfPerson.value,
      designationOfPerson: this.inspectionForm.controls.designationOfPerson.value,
      regdID: this.inspectionForm.controls.regdID.value,
      shares: this.inspectionForm.controls.shares.value,
      natureOfDocument: this.inspectionForm.controls.natureOfDocument.value,
      particulars: this.inspectionForm.controls.particulars.value,
      copyProvided: this.inspectionForm.controls.copyProvided.value,
      fees: this.inspectionForm.controls.fees.value,
      dateOfReceipt: this.setDate(this.inspectionForm.controls.dateOfReceipt.value),
      dateOfSupply: this.setDate(this.inspectionForm.controls.dateOfSupply.value),
      remarks: this.inspectionForm.controls.remarks.value,
    }

    this.InspectionService.updateInspection(inspectionObject, this.editInspectionId).subscribe(response => {
      if (response.status == 0) {
        this.disabledOnclick = false;
        this.alert.successWithOk(response.message, 'inspectionList');
      } else {
        // this.alert.error(response.err_fields + ' fields are required or invalid.');
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
          }
          else{
            this.alert.error(response.message);
          }
      }
    })
  }

  // fromTimeOfInspection
  getTimeOfInspection() {
    this.inspectionForm.controls.inspectionTimefrom.setValue($('#fromTimeOfInspection').val());
  }
  // toTimeOfInspection
  getTimeOfInspection1() {
    this.inspectionForm.controls.inspectionTimeto.setValue($('#toTimeOfInspection').val());
  }

  generateOutput() {
    var object = {
      id: this.editInspectionId,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.InspectionService.generateInspectionDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editInspectionId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editInspectionId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.InspectionService.downloadInspectionFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.InspectionService.downloadInspectionPdfFile(id, 'Single');
  }
}
